// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AddAccountType Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 50%;
  
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 0.5rem;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.modal-close-btn:hover {
  background: #dc3545;
  color: white;
  border-color: #dc3545;
}

.form-section {
  padding: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 0;
}

.form-label {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
}

.required-asterisk {
  color: #dc3545;
}

.form-control {
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
  padding: 0 1rem;
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.25rem 0;
}

.checkbox-label {
  font-size: 1.125rem;
  font-weight: 500;
  color: #333;
}

.form-check-input {
  width: 1.25rem;
  height: 1.25rem;
  margin-top: 0.25rem;
  cursor: pointer;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}

.submit-button {
  background-color: #0d6efd;
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 1.125rem;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  margin: 1rem auto;
  display: block;
}

.submit-button:hover:not(:disabled) {
  background-color: #0b5ed7;
}

.submit-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .modal-content {
    width: 90%;
    padding: 1rem;
  }
  
  .checkbox-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .checkbox-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/referenes/component/AddAccountType.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;;EAEV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* AddAccountType Modal Styles */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 999999999999999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  padding: 2rem;\r\n  border-radius: 8px;\r\n  width: 50%;\r\n  \r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  position: relative;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.modal-close-btn {\r\n  position: absolute;\r\n  top: 1rem;\r\n  right: 1rem;\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 4px;\r\n  padding: 0.5rem;\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.modal-close-btn:hover {\r\n  background: #dc3545;\r\n  color: white;\r\n  border-color: #dc3545;\r\n}\r\n\r\n.form-section {\r\n  padding: 1rem;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  padding: 0.25rem 0;\r\n}\r\n\r\n.form-label {\r\n  font-size: 1.125rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.required-asterisk {\r\n  color: #dc3545;\r\n}\r\n\r\n.form-control {\r\n  border: 1px solid #ced4da;\r\n  border-radius: 0.375rem;\r\n  padding: 0.5rem 0.75rem;\r\n  font-size: 1rem;\r\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\r\n}\r\n\r\n.form-control:focus {\r\n  border-color: #86b7fe;\r\n  outline: 0;\r\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\r\n}\r\n\r\n.checkbox-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 0.5rem;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.checkbox-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.25rem;\r\n  padding: 0.25rem 0;\r\n}\r\n\r\n.checkbox-label {\r\n  font-size: 1.125rem;\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.form-check-input {\r\n  width: 1.25rem;\r\n  height: 1.25rem;\r\n  margin-top: 0.25rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.error-message {\r\n  color: #dc3545;\r\n  font-size: 0.875rem;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.submit-button {\r\n  background-color: #0d6efd;\r\n  color: white;\r\n  font-weight: bold;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 0.5rem;\r\n  font-size: 1.125rem;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s ease-in-out;\r\n  margin: 1rem auto;\r\n  display: block;\r\n}\r\n\r\n.submit-button:hover:not(:disabled) {\r\n  background-color: #0b5ed7;\r\n}\r\n\r\n.submit-button:disabled {\r\n  background-color: #6c757d;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .modal-content {\r\n    width: 90%;\r\n    padding: 1rem;\r\n  }\r\n  \r\n  .checkbox-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .checkbox-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
